import type * as Api from 'Api'

export const searchErrorHandbook: Api.ErrorsHandbook<'default'> = {
  default: [],
}
